import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CountriesPageModule } from '../../../countries/countries.module';
import { AddPlayerComponent } from './add-player.component';
import { UploadImageModule } from '../upload-image/upload-image.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    CountriesPageModule,
    TranslateModule.forChild(),
    UploadImageModule,
  ],
  declarations: [AddPlayerComponent],
})
export class AddPlayerModule {}
